import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=3b0d61fe&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\webinane\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0d61fe')) {
      api.createRecord('3b0d61fe', component.options)
    } else {
      api.reload('3b0d61fe', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=3b0d61fe&", function () {
      api.rerender('3b0d61fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Button.vue"
export default component.exports